import moment from 'moment';

export const getRecurringOptions = (scheduledTime) => {
  if (!scheduledTime) {
    return [{
      value: null,
      name: 'N/A',
    }];
  }

  const time = moment(scheduledTime).utc();
  const hour = time.hours();
  const minute = time.minutes();
  const day = time.date();
  const weekday = time.weekday();

  return [
    {
      value: null,
      name: 'Not recurring',
    },
    {
      value: `${minute} ${hour} * * *`,
      name: 'Daily',
    },
    {
      value: `${minute} ${hour} * * 1-5`,
      name: 'Weekdays Only',
    },
    {
      value: `${minute} ${hour} * * ${weekday}`,
      name: 'Weekly',
    },
    {
      value: `${minute} ${hour} ${day} * *`,
      name: 'Monthly',
    },
  ];
};

// returns a moment object;
export const getNextTimeFromCron = (cron) => {

  if (!cron) { return null; }
  const arr = cron.split(' ');
  if (!arr.length) { return null; }
  const [minute, hour, day, month, weekday] = arr;
  const now = moment.tz("UTC");
  const next = moment.tz("UTC");

  next.set('minute', Number(minute));
  next.set('hour', Number(hour));

  const isAhead = next.isAfter(now);

  // daily
  if ([day, month, weekday].every((t) => t === '*')) {
    if (isAhead) { return next; }
    return next.add(1, 'day');
  }

  // weekday
  if (weekday === '1-5') {
    if (now.weekday() >= 1 && now.weekday() <= 5 && isAhead) {
      if (isAhead) { return next; }
    }

    if (now.weekday() === 6) {
      return next.add(2, 'day');
    }

    return next.add(1, 'day');
  }

  // weekly
  if (weekday !== '*') {
    if (now.weekday() === Number(weekday) && isAhead) {
      return next;
    }

    const diff = 7 - now.weekday() + Number(weekday);
    return next.add(Math.abs(diff), 'day');
  }

  // monthly left
  next.set('date', Number(day));
  if (next.isAfter(now)) {
    return next;
  }

  next.add(1, 'month');
  return next;
};